import { useState, useEffect, useCallback } from 'react';
import { useIdleMonitor } from 'hooks';
import { getLocalSettingsProxy } from 'utilities';

export const useInactivity = () => {
  const [openInactivityDialog, setOpenInactivityDialog] = useState(false);

  const onIdleTimeLimit = useCallback(() => {
    const localSettings = getLocalSettingsProxy();
    localSettings.sessionTracking.inactivityDialogExpiresAt = null;
    localSettings.sessionTracking.inactivityDialogOpen = true;
    setOpenInactivityDialog(true);
  }, []);

  useEffect(() => {
    const checkDialogState = () => {
      const localSettings = getLocalSettingsProxy();
      const dialogOpen = localSettings.sessionTracking.inactivityDialogOpen;
      const expiresAt = localSettings.sessionTracking.inactivityDialogExpiresAt;
      const shouldLogout = localSettings.sessionTracking.shouldLogout;

      if (shouldLogout) {
        localSettings.sessionTracking.shouldLogout = false;
        window.location.reload();
        return;
      }

      if (dialogOpen && !openInactivityDialog) {
        setOpenInactivityDialog(true);
      }

      if (!dialogOpen && openInactivityDialog) {
        setOpenInactivityDialog(false);
      }

      if (expiresAt && Date.now() >= expiresAt) {
        if (!openInactivityDialog) {
          setOpenInactivityDialog(true);
        }
      }
    };

    window.addEventListener('focus', checkDialogState);
    window.addEventListener('blur', checkDialogState);
    checkDialogState();

    return () => {
      window.removeEventListener('focus', checkDialogState);
      window.removeEventListener('blur', checkDialogState);
    };
  }, [openInactivityDialog]);

  const restartTimer = useIdleMonitor(onIdleTimeLimit);

  const inactivityDialogAction = useCallback(() => {
    restartTimer();
    setOpenInactivityDialog(false);
  }, [restartTimer]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (
        e.key &&
        e.key.includes('sessionTracking.shouldLogout') &&
        e.newValue === 'true'
      ) {
        const localSettings = getLocalSettingsProxy();
        localSettings.sessionTracking.shouldLogout = false;
        window.location.reload();
        return;
      }

      if (
        e.key &&
        e.key.includes('sessionTracking.inactivityDialogOpen') &&
        e.newValue === 'true' &&
        !openInactivityDialog
      ) {
        setOpenInactivityDialog(true);
      }

      if (
        e.key &&
        (e.key.includes('sessionTracking.mostRecentActivityTimestamp') ||
          (e.key.includes('sessionTracking.inactivityDialogOpen') &&
            e.newValue === 'false'))
      ) {
        setOpenInactivityDialog(false);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [openInactivityDialog]);

  return {
    openInactivityDialog,
    inactivityDialogAction,
  };
};
